module.exports = __webpack_public_path__ + "img/User_input_to_Molecule.1f2f7523.gif";